export default {
    id:'es',
    wellcome: {
        our_mission:'Nuestra misión',
        our_vission: 'Nuestra visión',
        our_values: 'Nuestros valores',
        link: 'https://www.goodhope.org.pe/quienes-somos',
        more_information: 'Mas informacion', 
        vission: 'Seremos una clínica acreditada con estándares internacionales, manteniendo la mejor experiencia para nuestros asegurados, pacientes y comunidades; brindando asistencia social a los más vulnerables',
        mission: 'Somos una clínica de la red médica adventista mundial que continúa el ministerio sanador de Cristo, cuidando la salud física, mental, espiritual y social de nuestros asegurados de Garantía de Salud, pacientes y comunidades; brindando asistencia social a los más vulnerables',
        values: ['Dependencia de Dios', 'Integridad', 'Vocación de Servicio', 'Compromiso', 'Mejora Continua', 'Compasión'],
        slogan: 'Servir, Sanar y Salvar',
        sloganLarge: ['Servir con mejora continua y vocación de servicio', 'Sanar con compromiso e integridad', 'Salvar con compasión y dependencia de Dios']
      
    },
    login: {
        user: 'Usuario',
        userPlaceholder: 'Mi usuario',
        password: 'Contraseña',
        passwordPlaceholder: 'Mi contraseña',
        button: 'Ingresar',
        quest: '¿Olvidaste la contraseña?',
        forgotMessage: 'Comunicarse con TI de su institución',
        logoAdv : '',
        logoRed: '',
        logoBall: '../assets/logo_groups.gif',
        exit:'Salir',
        error: {
            server_undefined: 'No es posible contactar con el servicio',
            server_error: 'Tenemos problemas al validar sus credenciales',
            password: 'Credenciales no válidas' 
        }
    },
    loading:{
        text: 'Buscando información'
    },

    common: {
        save: 'Guardar',
        saving: 'Guardando',
        loading: 'Cargando',
        name: 'Nombre',
        description: 'Descripción',
        error: 'Error',
        type: 'Tipo',
        user: 'Usuario',
        option: 'Opción',
        options: 'Opciones',
        option_short: 'Opc',
        leadership: 'Liderazgo',
        kpi: 'Indicador',
        kpis: 'Indicador | Indicadores',
        company: 'Empresa',
        plan: 'Planificación',
        sector: 'Sector',
        period: 'Periodo',
        state: 'Estado',
        agreement : 'Acuerdo',
        group: 'Perspectiva',
        stereotype:'Estereotipo',
        acreditation: 'Acreditación',
        perspective: 'Perspectiva',
        init: 'Desde',
        end: 'Hasta', 
        observation: 'Observación',
        comment: 'Comentario',
        code: 'Código',
        new: 'Nuevo',
        add: 'Agregar',
        edit: 'Editar',
        agreements: 'Acuerdo | Acuerdos',
        quality: 'Calidad',
        control_managment: 'Gestión de control',
        provider: 'Proveedor',
        client: 'Cliente' ,
        date: 'Fecha',
        clean: 'Limpiar',
        delete: 'Eliminar',
        defuse: 'Desactivar',
        active: 'Activar',
        total: 'Total',
        all: 'Todos',
        report: 'Reporte',
        download: 'Descargar',
        measure: 'medida',
        history: 'Historial',
        back:'Volver',
        approve: 'Aprobar',
        yes: 'Si',
        no: 'No',
        points: 'Puntos',
        kpi_xs: 'KPI',
        stereotype: 'Estereotipo',
        search: 'Buscar',
        role:'Rol',
        cancel:'Cancelar',
        update:'Actualizar',
        sorter: 'Orden',
        manager: 'Colaborador',
        controller: 'Controller',
        avaliador: 'Evaluador',
        template:'Plantilla',
        created: 'Creado',
        updated:'Actualizado',
        saved: 'Guardado',
        progress: 'Cumplimiento',
        day:'Día',
        evaluator: 'Evaluador',
        percentProgress: 'Porcentagem alcançada'
    },

    kpi:{
        upload_evidence: 'Subir evidencia',
        upload_file: 'Subir archivo',
        upload_see: 'Subir archivo',
        upload_name : 'Nombre del archivo',
        attachment_file: 'Archivos adjuntos',
        not_avariable: 'No disponible',
        upload_set_file: 'Por favor subir un archivo',
        upload_set_name: 'Por favor ingresar un nombre',
        upload_ok : 'Se guardó el archivo',
        upload_ko: 'Error al guardar el archivo',
        upload_delete_ok: 'Se eliminó el archivo',
        upload_delete_ko: 'Error al eliminar archivo',
        upload_download_ko: 'Error al descargar archivo',

        stereotypes:'Estereotipos',
        acreditations: 'Acreditaciones',

        measure: 'Ingrese la medida',
        write: 'Ingrese su análisis aquí',
        measure_ko: 'No cumplió con la meta',
        measure_ok: 'Ha alcanzado la meta',
        measure_value: 'Alcanzado',
        analysis: 'Análisis',
        formula: 'Fórmula',
        level: 'Nivel',
        kpi: 'Indicador',
        goal: 'Meta',
        result: 'Alcanzado',
        percent: '% Cumplimiento',
        method: 'Método',
        check: 'Evaluación',
        checker: 'Evaluador',
        checked: 'Evaluado',
        history: 'Historial',
        history_title: 'Historial de cambio',
        commentary: 'Comentario',
        measure_null: 'No tenemos medida aún',
        maxLength:'Cuidado con sobrepasar el límite permitido de caracteres',
        selectSector: 'Seleccione un sector para continuar',
        configTitle: 'Administración de indicadores',
        unit: 'Unidad',
        complete_no: 'Sin cumplir',
        complete_yes: 'Ha cumplido'

    },

    sector: {
        sector: 'Sector',
        search: 'Buscar sector',
        form: 'Datos del sector',
        children: 'Sectores asociados',
        children_ko: 'No hay setores associados',
        users: 'Usuarios relacionados',
        type: 'Tipo de sector',
        select_please: 'Por favor seleccione un sector',
        selectSector: 'Selecione um setor para continuar',
    },

    plan: {
        complete: 'No hay pendientes para este sector',
        doing: 'En progreso',
        action_plan: 'Plan de acción',
        kpi: 'Indicador (Indicador General KPI)',
        kpi_goal: 'Meta KPI',
        rk: 'KR - Resultado Clave',
        kr_actual: 'R Actual',
        kr_goal: 'Meta KR',
        kr_days: 'Tiempo (días)',
        kr_result: 'Resultado',
        reason: '¿Por qué lo hará? ',
        reason_description: 'Identifique el inicio del problema',
        reason_other: 'Otro motivo',
        plan_how_kr: '¿Cómo logrará el KR?',
        plan_what: '¿Qué se hará?',
        plan_how: '¿Cómo se hará?',
        plan_who: '¿Quién lo hará?',
        plan_when: '¿Cuándo se hará?',
        plan_where:  '¿Dónde se hará?',
        plan_cost: '¿Cuánto costará?',
        plan_when_description: 'colocar la cantidad de días que se realizará',
        do_init: 'Fecha inicio',
        do_end: 'Fecha final',
        check_advance: 'Tipo de avance',
        check_pass: 'Revisiones anteriores',
        collaboration: 'Colaboración',
        collaboration_sector: 'Sector a comunicar',
        collaboration_past: 'Comunicaciones pasadas',
        act: 'Comentarios para el área de calidad'

    },

    risk: {
        type: 'Tipo de riesgo por el incumplimiento del indicador',
        risk: 'riesgo en la experiencia del paciente por el incumplimiento del indicador',
        impact: 'Impacto por incumplimiento del indicador',
        category: 'Categoría ' ,
        operational: 'Criterio operacional',
        legal: 'Criterio regulatorio',
        finance:'Criterio financiero'
    },

    ose: {
        kpi: 'Datos del indicador',
        type: 'Tipo de indicador',
        class: 'Clasificación OSE'
    },

    checklist: {
        nothing: 'No hay indicadores tipo CHECKLIST para este sector',
        new: 'Nuevo checklist'
    },

    review : {
        result: 'Resultado',
        controller: 'Controller',
        feedback: 'Evaluador',
        complete: 'Cumplió la meta',
        evidence: 'Evidencia',
        analysis: 'Análisis',
        kpi_sector: 'INDICADORES RELACIONADOS POR SECTORES'
    },
    
    agreement: {
        as_provider: 'Mis Acuerdos Con otros-Proveedor',
        as_client: 'Mis Acuerdos - Cliente',
        motive: 'Motivo del contrato',
        time: 'Plazo',
        preview: 'Requisito previo',
        my: 'Mi acuerdo',
        sign: 'Firmado el ',
        complete: 'Cumplió con el acuerdo',
        complete_ko: 'Motivo del incumplimiento',
        confirm_message: 'Confirmado el {date} por el usuario {user} ',
        confirm_title: 'Confirmar acuerdo',
        new:'Nuevo acuerdo',
        edit: 'Editar acuerdo',
        approve: 'Aprobar acuerdo',
        review: 'Evaluación del acuerdo',
        confirm_delete: '¿Esta Seguro Que desea Eliminar este acuerdo?',
        period_out: 'Periodo vencido'
    },

    report : {
        title:'Reportes',
        dashboard: {
            title: 'Dashboard',
            group_point : 'Distribución de puntaje por perspectiva',
            stereotype_point: 'Distribución de puntaje por estereotipo',
            total_point: 'Total de puntos',
            percent: 'Porcentaje logrado',
            kpi_detail: 'Listado detallado de indicadores',
            average: 'Promedio'
        },
        ranking : {
            title: 'Ranking',
            unit: 'Unidad administrativa'
        },
        history: {
            title: 'Histórico'
        },
        plan: {
            title: 'Planes'
        },
        accreditation:{
            title: 'Acreditación'
        },
        ose: {
            title: 'OSE'
        },
        risk: {
            title: 'Riesgos'
        },
        epr: {
            title : 'ERP',
            perspectiveChart:'Distribución por perspectiva',
            percent: 'Porcentaje alcanzado',
            distribution: 'Distribución por EPR',
            abstract: 'Resumen',
            no_classification: 'No clasificado'

        }
    },

    config: {
        title: 'Configuraciones',
        company:'Configuración de la compañia',
        basic: 'Configuraciones basicas',
        menu : {
            user: 'Usuarios',
            plan: 'Planificaciones',
            objetive: 'Tipo de objetivos',
            sectorType: 'Tipo de sectores',
            leadership: 'Liderazgos',
            smtp: 'SMTP',
            sectors: 'Sectores',
            groups: 'Perspectivas',
            periods: 'Periodos',
            stereotypes : 'Stereotipos',
            blocks: 'Bloqueos',
            integrations: 'Integraciones',
            template: 'Plantillas',
            kpi: 'Indicadores',
            objetives: 'Objetivos',
            ranking: 'Cálculos'
        },
        users:{
            title: 'Gerenciamento de usuários',
            search:'Buscar usuario',
            newUser:'Nuevo usuario',
            confirmDelete: '¿Esta seguro de eliminar el usuario en la institución?',
            create:'Crear usuario',
            import: 'Importar usuario',
            userExists: 'Usuario ya registrado',
            personalData: 'Datos personales',
            credentials: 'Credenciales',
            addSector: 'Agregar sector',
            successfull: 'Usuario creado'

        },
        sector:{
            title: 'Administración de sectores',
            delete: 'Eliminar sector',
            deleteMessage: 'La eliminación de un sector puede afectar mucho el sistema, por favor eliminar con responsabilidad'
        },
        sectorType: {
            title: 'Administración de tipo de sector',
            kpiMark: 'Etiqueta',
            level: 'Nivel',
            asesor: 'Evaluador',
            kpiLetter: 'Letra',
            new: 'Nuevo tipo de sector'
        },
        period: {
            title: 'Administración de periodos',
            start: 'Fecha de início',
            end: 'Fecha de fin',

        },
        kpi:{
            title: 'Formulario de edición de los indicadores',
            new: 'Nuevo indicador',
            createFromTemplate: 'Crear desde plantilla',
            kpiChildren: 'Indicadores relacionados',
            kpiFather: 'Indicador padre',
            method: 'Método',
            integrations: 'Integraciones',
            kpiData: 'Datos del indicador',
            generalData: 'Datos generales',
            pdca: 'Este indicador califica para PDCA',
            delete: 'Eliminar un KPI podría ocasionar inestabilidad en el sistema. La eliminación implica también eliminar los KPI relacionados de otros sectores. Use con precausión',
            confirmDelete: '¿Seguro de eliminar?',
            withoutTemplate: 'Sin plantilla'

        }
    },
    menu: {
        operational: 'Analis. Operacional',
        tactic: 'Analis. Tactico',
        strategic: 'Analis. Estratégico',
        plan: 'Planes',
        process: 'Procesos',
        map: 'Mapa',
        risk: 'Riesgo',
        ose: 'OSE',
        epr: 'EPR',
        checklist: 'Checks',
        advance: 'Avances',
        review: 'Evaluar',
        agreement: 'Acuerdos',
        report: 'Reportes',
        config: 'Configurar'
    },
    process:{
        register: 'Registro de procesos',
        add: 'Agregar proceso',
        confirmDelete: '¿Seguro de eliminar?',
    },
    ose:{
        title: 'Eficiencia general del servicio',
        kpiType:'Tipo indicador',
        areaSelect: 'Seleccione el área',
        classification: 'Clasificación OSE',
        classificationSelect: 'Seleccione una clasificación',
        detail:'Ingrese un detalle',
        error:'Complete el formulario',
        registed: 'Registrados',
        unckecked: 'pendientes',
        order: 'Distribución OSE',
        kpiCount: 'Cantidad de indicadores',
        chartTitle: 'Cantidad de indicadores por clasificaión OSE',
        chartSubTitle: 'Indicadores por OSE',
        unassigned: 'Sin asignar',
        kpiList: 'Listado de indicadores',
        kpiRecord: 'Indicadores registrados',
        kpiPercent: 'Cumplimiento porcentual'

    },
    progress: {
        title: 'Avance de completado de Indicadores',
        grade: 'Evaluaciones',
        no_grade: 'Sin evaluaciones',
        get_data: 'Obtener información de hijos'
    },
    evaluation:{
        title: 'Evaluar indicadores',
        profile: 'Perfil'
    },
    epr:{
        title: 'EPR',
        kpiList: 'Listado de indicadores',
        slogan: 'Nuestra misión'
    }
}

